// initialValues.js
const samvatInitialValues = {
  start_time: "",
  end_time: "",
  value: null,
};
export default samvatInitialValues;
